// Rutas cuya navegacion puede seguir el pixel de Meta. Es lista BLANCA, no lista
// negra: una ruta nueva no entra sola, hay que anadirla a mano. Fuera quedan tres
// cosas que no deberian llegar nunca a Meta:
//
//   - /app/**: la aplicacion con sesion iniciada. Meta recibia la URL de cada
//     pantalla que miraba un usuario dentro de una app financiera, y para anunciar
//     no vale nada: nadie optimiza campanas sobre la navegacion de quien ya se dio
//     de alta.
//   - /p/:id: cartera compartida. No pide sesion, pero son las posiciones de alguien.
//   - /reset-password y /verify-email: llevan el token EN la URL, y el PageView
//     envia la URL entera. Un token de recuperacion de contrasena viajaba a Meta.
//
// Vive aparte de metaPixel.js para poder probarse: ese modulo importa con el alias
// @/, que solo existe en webpack y no en jest.
const PUBLIC_EXACT = new Set([
    "/",
    "/pricing",
    "/asesores",
    "/en/advisors",
    "/login",
    "/register",
    "/download",
    "/descargar",
    "/radiografia",
    "/compensar-perdidas",
    "/sorteo",
    "/prensa",
    "/calculadora-fiscal",
    "/blog",
    "/legal",
]);

const PUBLIC_PREFIXES = ["/blog/", "/legal/", "/r/", "/comparativa/", "/brokers/"];

export function isTrackableRoute(pathname) {
    if (PUBLIC_EXACT.has(pathname)) return true;
    return PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
